import React, { useEffect, useState } from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function VerifyPage() {
  const [searchParams] = useSearchParams();
  const { checkSession, user } = useAuth();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [errorMsg, setErrorMsg] = useState('');
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setErrorMsg('No token provided.');
      return;
    }

    // The /api/verify endpoint sets a cookie and redirects via 302.
    // Since we're calling it from React, we use fetch with redirect: 'manual'
    // to capture the cookie without following the redirect.
    async function verify() {
      try {
        const res = await fetch(`/api/verify?token=${encodeURIComponent(token)}`, {
          credentials: 'include',
          redirect: 'manual',
        });

        // A 302 redirect means success (cookie was set)
        // With redirect: 'manual', fetch returns an opaque redirect response (type === 'opaqueredirect')
        if (res.type === 'opaqueredirect' || res.status === 302 || res.ok) {
          await checkSession();
          setStatus('success');
        } else {
          setStatus('error');
          setErrorMsg('Invalid or expired token.');
        }
      } catch {
        setStatus('error');
        setErrorMsg('Verification failed. Please try again.');
      }
    }

    verify();
  }, [token, checkSession]);

  if (status === 'success' || user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="page verify-page">
      <div className="login-card">
        <h1>Ridge Sports</h1>
        {status === 'verifying' && (
          <div className="loading">Verifying your login...</div>
        )}
        {status === 'error' && (
          <>
            <div className="alert alert-error">{errorMsg}</div>
            <a href="/login" className="btn btn-primary btn-full">Back to Login</a>
          </>
        )}
      </div>
    </div>
  );
}
